import ApprovePayments from './ApprovePayments';
import GettingStarted from './GettingStarted';
import Verification from './Verification';

export { ApprovePayments, GettingStarted, Verification };
